export default __webpack_public_path__ + "static/media/icon-email.ca757631.svg";